/** Admin: sales requests, invoiced (manual) billing ng isang workspace, at custom (Institution) plan terms (DEC-155). */
export const salesRequests = {
  title: "Mga sales request",
  subtitle: "Ang hiniling ng mga workspace sa sales. Kontakin sila, tapos i-assign ang plan at add-on sa Billing tab nila.",
  search: "Maghanap ng workspace o contact",
  filters: { all: "Lahat", new: "Bago", contacted: "Nakontak", done: "Tapos" },
  statuses: { new: "Bago", contacted: "Nakontak", done: "Tapos" },
  status: "Status",
  ref: "Request",
  workspace: "Workspace",
  wanted: "Hinihingi",
  terms: "Cycle at mga seat",
  contact: "Contact",
  received: "Natanggap",
  notes: "Mga tala nila",
  plan: "{{plan}} plan",
  addonsOnly: "Mga add-on lang",
  seats: "{{count}} seat",
  cycles: { monthly: "Buwanan", annual: "Taunan" },
  emptyTitle: "Walang sales request dito",
  emptyBody: "Kapag humiling ang isang workspace na magbayad sa ibang paraan o makipag-usap sa sales, lalabas ang request dito.",
  emptySearch: "Walang request na tumutugma sa paghahanap.",
  review: {
    action: "Suriin",
    title: "Sales request SR-{{number}}",
    staffNote: "Tala ng staff",
    staffNoteHint: "Platform staff lang ang nakakakita nito.",
    save: "I-save",
    saved: "Na-update ang SR-{{number}}",
    assign: "I-assign ang plan at mga add-on",
  },
} as const;

export const manualBilling = {
  badge: "Sinisingil sa invoice",
  card: "Invoiced na termino",
  term: "Termino",
  agreedPrice: "Napagkasunduang presyo ng plan",
  catalogPrice: "Presyo sa catalogue",
  staffNote: "Tala ng staff",
  addons: "Mga add-on",
  none: "Wala",
  assign: "Mag-assign ng invoiced na plan",
  edit: "I-edit ang invoiced na termino",
  handBack: "Ibalik sa self-serve",
  handBackTitle: "Ibalik sa self-serve billing?",
  handBackBody: "Mananatili ang plan, mga add-on at petsa. Sa petsa ng pagtatapos, tatakbo ang karaniwang renewal: sisingilin ang naka-save na PayPal account, o hihilingin sa owner na magbayad.",
  handBackDone: "Naibalik sa self-serve billing",
  neverCharged: "Hindi kailanman awtomatikong sinisingil. Ipapaalala sa admin bago ang petsa ng pagtatapos.",
  dialogTitle: "Invoiced na plan para sa {{tenant}}",
  dialogBody: "Manual ang billing: ang Sagot ang nag-iinvoice sa labas ng produkto at walang sinisingil. Agad na gumagana ang mga feature ng plan at add-on.",
  plan: "Plan",
  cycle: "Billing cycle",
  monthly: "Buwanan",
  annual: "Taunan",
  startsOn: "Petsa ng simula",
  endsOn: "Petsa ng pagtatapos o renewal",
  price: "Napagkasunduang presyo ng plan (opsyonal)",
  priceHint: "Kapag walang laman, gagamitin ang presyo sa catalogue. Ipapakita sa workspace bilang napagkasunduang presyo.",
  addonsLegend: "Mga add-on sa terminong ito",
  addonsHint: "Ito ang kumpletong listahan: ang tumatakbong add-on na hindi naka-tick ay matatapos agad.",
  quantity: "Dami ng {{name}}",
  note: "Tala (staff lang)",
  noteHint: "Numero ng invoice, reference ng kontrata, anumang kailangan ng team.",
  save: "I-save ang invoiced na termino",
  saved: "Na-save ang invoiced na termino",
  loadError: "Hindi ma-load ang mga plan at add-on.",
  datesOrder: "Dapat mas huli ang petsa ng pagtatapos kaysa sa simula.",
} as const;

export const customPlan = {
  title: "Mga termino ng Institution",
  body: "Walang list price ang Institution, kaya sa invoice ito sinisingil. Mananatili ang mga limit na ito hanggang baguhin mo.",
  invoiced: "Billing mode: manual / invoiced. Walang awtomatikong sinisingil.",
  price: "Custom na presyo kada buwan (opsyonal)",
  priceHint: "Iwanang blangko o 0 para sa manual na invoice na walang nakasaad na presyo.",
  limitsLegend: "Mga limit",
  messages: "Mga mensahe kada buwan",
  agents: "Mga agent",
  seats: "Mga seat",
  storage: "Knowledge storage (GB)",
  unlimited: "Walang limitasyon",
  unlimitedFor: "Walang limitasyon ang {{limit}}",
  note: "Tala (staff lang)",
  scheduled: "Naka-iskedyul ang Institution sa susunod na renewal",
  appliedNow: "Sinisingil na sa invoice ang {{plan}}",
  invalid: "Maglagay ng buong numero, o i-tick ang Walang limitasyon.",
  invalidPrice: "Maglagay ng presyong 0 o higit pa.",
} as const;
